import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-filter-icon',
  standalone: true,
  template: `
    <svg
      [class]="iconClass()"
      [attr.width]="width()"
      [attr.height]="height()"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.117 18.875C8.717 18.875 8.32533 18.775 7.95866 18.575C7.22533 18.1667 6.78366 17.425 6.78366 16.5917V12.175C6.78366 11.7583 6.50866 11.1333 6.25033 10.8167L3.13366 7.51667C2.60866 6.99167 2.20866 6.09167 2.20866 5.41667V3.5C2.20866 2.16667 3.217 1.125 4.50033 1.125H15.5003C16.767 1.125 17.792 2.15 17.792 3.41667V5.25C17.792 6.125 17.267 7.11667 16.7753 7.60833L13.167 10.8C12.817 11.0917 12.542 11.7333 12.542 12.25V15.8333C12.542 16.575 12.0753 17.4333 11.492 17.7833L10.342 18.525C9.967 18.7583 9.542 18.875 9.117 18.875ZM4.50033 2.375C3.917 2.375 3.45866 2.86667 3.45866 3.5V5.41667C3.45866 5.725 3.70866 6.325 4.02533 6.64167L7.20033 9.98333C7.62533 10.5083 8.042 11.3833 8.042 12.1667V16.5833C8.042 17.125 8.417 17.3917 8.57533 17.475C8.92533 17.6667 9.35033 17.6667 9.67533 17.4667L10.8337 16.725C11.067 16.5833 11.3003 16.1333 11.3003 15.8333V12.25C11.3003 11.3583 11.7337 10.375 12.3587 9.85L15.9253 6.69167C16.2087 6.40833 16.5503 5.73333 16.5503 5.24167V3.41667C16.5503 2.84167 16.0837 2.375 15.5087 2.375H4.50033Z"
        fill="currentColor" />
      <path
        d="M4.99974 8.95741C4.88307 8.95741 4.77474 8.92408 4.6664 8.86575C4.37474 8.68241 4.28307 8.29075 4.4664 7.99908L8.57474 1.41575C8.75807 1.12408 9.1414 1.03241 9.43307 1.21575C9.72474 1.39908 9.8164 1.78241 9.63307 2.07408L5.52474 8.65741C5.40807 8.84908 5.20807 8.95741 4.99974 8.95741Z"
        fill="currentColor" />
    </svg>
  `,
})
export class FilterIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 20 20');
}
